import { cva, VariantProps } from 'class-variance-authority';
import { cn } from '@/components/ui/utils';
import { NavLink, NavLinkProps } from 'react-router-dom';

const styles = cva('text-sm text-primary font-semibold disabled:pointer-events-none', {
  variants: {},
  defaultVariants: {},
});

export type TappLinkProps = {} & VariantProps<typeof styles> & NavLinkProps;

export const TappLink: React.FC<TappLinkProps> = ({ to, children, className, ...props }) => {
  return (
    <NavLink to={to} className={cn(styles({}), className)} {...props}>
      {children}
    </NavLink>
  );
};
